import { query } from "./strapi";

export interface FreebieLeadData {
  productId: string;
  name: string;
  email: string;
  phone: string;
  source: string;
}

export interface FreebieDownloadResponse {
  success: boolean;
  downloadUrl?: string;
  message?: string;
}

export const freebieService = {
  /**
   * Create a lead for freebie download
   */
  createLead: async (leadData: FreebieLeadData): Promise<any> => {
    try {
      const response = await query("freebies/create-lead", {
        method: "POST",
        body: JSON.stringify(leadData),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.success) {
        throw new Error(response.message || "Failed to create lead");
      }

      return response.data;
    } catch (error) {
      console.error("Error creating freebie lead:", error);
      throw error;
    }
  },

  /**
   * Get download URL for a freebie
   */
  getDownloadUrl: async (
    productId: string,
    email: string
  ): Promise<FreebieDownloadResponse> => {
    try {
      const response = await query(`freebies/${productId}/download-url`, {
        method: "POST",
        body: JSON.stringify({ email }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response;
    } catch (error) {
      console.error("Error getting download URL:", error);
      throw error;
    }
  },

  /**
   * Track freebie events
   */
  trackEvent: (eventType: string, productId: string, additionalData?: any) => {
    // Track with Google Analytics if available
    if (typeof (window as any).gtag !== "undefined") {
      (window as any).gtag("event", eventType, {
        event_category: "Freebie",
        event_label: productId,
        value: 1,
        ...additionalData,
      });
    }

    // Track with other analytics services as needed
    console.log("Freebie event tracked:", {
      eventType,
      productId,
      ...additionalData,
    });
  },
};

export default freebieService;
